import React from 'react'
import Description from './Description'
import List from './List'

const Projekt = () => {
  return (
    <section id="projekt">
      <Description />
      <List />
    </section>
  )
}

export default Projekt
